import React, { Component } from "react";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as wActs from '../actions/website-actions';
import {FormattedMessage} from "react-intl";
import CountrySelect from "./countryselect";

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileMenuOpen: false,
      searchTxt: ""
    };
    this.showLogin = this.showLogin.bind(this);

  }

  showLogin() {
    this.props.dispatch(wActs.showLogin());
  }

  toggleMenu(e) {
    e.preventDefault();

    if (this.state.mobileMenuOpen) {
      //document.documentElement.classList.remove("no-scroll");
      this.setState({mobileMenuOpen: false});
    } else {
      //document.documentElement.classList.add("no-scroll");
      this.setState({mobileMenuOpen: true});
    }
  }

  handleKeyPress(event) {
    if(event.key === 'Enter'){
      event.preventDefault();
      this.props.history.push(wActs.getCultPath(this.props.WebPage,"/search?term=" + escape(this.state.searchTxt)));
      this.handleSideMenuClick();
      //this.props.dispatch(pActs.searchProfiles(this.state.searchTxt));
      return;
    }
  }

  handleChange(event) {
    this.setState({searchTxt: event.target.value})
  }

  handleSearchButton(event) {
    event.preventDefault();
    this.props.history.push(wActs.getCultPath(this.props.WebPage,"/search?term=" + escape(this.state.searchTxt)));
    this.handleSideMenuClick();
  }

  searchProfiles() {

  }

  domainLogo() {
    let ref = this.props.ServerParams.Referer;
    if (typeof ref === "undefined") {
      ref = "https://stage.redlight.nl:3000/";
    }
    let domain = ref.replace("https://").replace("http://").split("/")[0];
    domain = domain.split(":")[0];
    domain = domain === "localhost" || domain.startsWith('10.') ? "www.redlight.nl" : domain;
    let name = "";
    let prts = domain.split(".");
    name = prts[prts.length-2];
    return ( <img src={`/imgs/${name}.svg`} alt="" /> );
  }

  handleLogout(e) {
    e.preventDefault();
    //localStorage.removeItem('siteways-bearer');
    wActs.removeCookie("auth");
    window.location.reload();
  }

  handleSideMenuClick() {
    //document.documentElement.classList.remove("no-scroll");
    this.setState({mobileMenuOpen: false});
    //window.HideSideMenu();
  }

  handleSeoClick(e) {
    e.preventDefault();
    window.open(`${this.props.WebPage.Settings.DashUrl}/seo?ref=${escape(window.location.href)}`)
    //this.props.dispatch(wActs.LoadPageSeo());
  }
  handleSettingsClick(e) {
    e.preventDefault();
    window.open(`${this.props.WebPage.Settings.DashUrl}/domain?ref=${escape(window.location.href)}`)
    //this.props.dispatch(wActs.LoadPageSeo());
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  hasRole(role) {
    let hasRole = false;
    let user = this.props.WebPage.User;
    if(!wActs.isNullOrUndefined(user.Roles) && user.Roles.length) {
      user.Roles.map((v) => {
        if(v === role) {
          hasRole = true;
        }
      })
    }
    return hasRole;
  }


  selectedLocale() {
    let loc = this.props.WebPage
  }

  getTerm() {
    let url = "";
    if(typeof window !== "undefined") {
      url = window.location.href;
    } else {
      url = "https://www.fakeurl.com" + this.props.WebPage.ServerParams.Query;
    }
    return wActs.getParameterByName("term", url, "");
  }

  render() {

    //console.log("UserId", this.props.WebPage.User.UserId);
    let hLink = wActs.getCultPath(this.props.WebPage,"/");
    if(hLink.endsWith("/")) { hLink = hLink.substr(0,hLink.length -1)}
    let term = this.getTerm();
    let mob = this.props.WebPage.ServerParams.IsMobile;

    return (
      <header className="header">
        <div className="container flex flex--between flex--center">
          <div className="logo">
            <Link to={wActs.getCultPath(this.props.WebPage, "/")}><img src="/imgs/logo.png" alt={this.props.WebPage.Settings.SiteName} /></Link>
          </div>
          <CountrySelect/>
        </div>
      </header>
  );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    ServerParams: state.Website.ServerParams
  };
}

export default withRouter(connect(mapStateToProps)(Header));
